module.exports = __webpack_public_path__ + "static/media/0_2018_11_01.5fc549e4.jpg";